module.exports = __webpack_public_path__ + "img/eye.7b92d3c5.svg";